/*
 * @Author: my
 * @Date: 2022-05-16 14:27:03
 * @LastEditors: my
 * @LastEditTime: 2022-05-16 14:40:58
 */
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import {
  get_question,
  wx_auth,
  works_add,
  update_score,
  draw,
  winninginfo,
} from "@/service/api.js";
const Store = new Vuex.Store({
  state: {
  },
  mutations: {
    //同步逻辑处理
  },
  actions: {
    get_question({ commit },param={}){
      return new Promise((resolve, reject) => {
        get_question(param).then(res=>{
          resolve(res)
        }).catch((res)=>{
          reject(res)
        })
      })
    },
    wx_auth({ commit },param={}){
      return new Promise((resolve, reject) => {
        wx_auth(param).then(res=>{
          resolve(res)
        }).catch((res)=>{
          reject(res)
        })
      })
    },
    works_add({ commit },param={}){
      return new Promise((resolve, reject) => {
        works_add(param).then(res=>{
          resolve(res)
        }).catch((res)=>{
          reject(res)
        })
      })
    },
    update_score({ commit },param={}){
      return new Promise((resolve, reject) => {
        update_score(param).then(res=>{
          resolve(res)
        }).catch((res)=>{
          reject(res)
        })
      })
    },
    draw({ commit },param={}){
      return new Promise((resolve, reject) => {
        draw(param).then(res=>{
          resolve(res)
        })
      })
    },
    winninginfo({ commit },param={}){
      return new Promise((resolve, reject) => {
        winninginfo(param).then(res=>{
          resolve(res)
        })
        // .catch(res=>{
        //   reject(res)
        // })
      })
    },
  },
});
export default Store

